
export enum TrackingTypes {
    Contact = 'contact',
    Social = 'social',
    Download = 'download',
    OutgoingLink = 'Outgoing links',
    Other = 'other',
}
